export default {"src":"/_next/static/media/pineapple.de8717dc.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};